var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vector"},[_c('svg',{attrs:{"viewBox":_vm.viewbox,"xmlns":_vm.xmlns,"preserveAspectRatio":_vm.$props.preserveAspectRatio},domProps:{"innerHTML":_vm._s(_vm.dummy.innerHTML)}})])}
var staticRenderFns = []

export { render, staticRenderFns }